<template>
  <div class="section-card">
    <div class="section-header">
      <div class="section-title">
        <div class="icon-wrap">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </div>
        Your Account Health
      </div>
    </div>

    <div class="featured-gate" :class="isFeaturedMerchant ? '' : 'not-eligible'">
      <div class="featured-gate-icon" :class="isFeaturedMerchant ? '' : 'critical'">
        <svg v-if="isFeaturedMerchant" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div>
        <div class="featured-gate-label">Featured Merchant: {{ isFeaturedMerchant ? 'Eligible' : 'Not Eligible' }}</div>
        <div class="featured-gate-sub">{{ isFeaturedMerchant ? 'You can compete for the Buy Box on this ASIN' : 'You cannot win the Buy Box on this ASIN' }}</div>
      </div>
      <span class="featured-gate-code">IsFeaturedMerchant: {{ isFeaturedMerchant ? 'true' : 'false' }}</span>
    </div>

    <div class="health-metrics" v-if="(accountHealth.metrics || []).length">
      <div
        v-for="(metric, index) in (accountHealth.metrics || [])"
        :key="index"
        class="health-metric"
      >
        <span class="health-metric-name">{{ metric.name }}</span>
        <span class="health-metric-value" :class="metric.status">{{ metric.value }} <span class="threshold">{{ metric.threshold }}</span></span>
      </div>
    </div>

    <div class="health-note">
      These metrics govern your <strong>Featured Merchant</strong> status. If ODR exceeds 1%, Amazon can revoke Buy Box eligibility account-wide — <code>IsFeaturedMerchant</code> flips to <code>false</code> and you cannot win any Buy Box regardless of price.
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountHealth',
  props: {
    accountHealth: {
      type: Object,
      required: true
    },
    isFeaturedMerchant: {
      type: Boolean,
      default: true
    }
  }
}
</script>




// WEBPACK FOOTER //
// AccountHealth.vue?59627cfd